import { render, staticRenderFns } from "./TableInvoice.vue?vue&type=template&id=876f4434&"
import script from "./TableInvoice.vue?vue&type=script&lang=js&"
export * from "./TableInvoice.vue?vue&type=script&lang=js&"
import style0 from "./TableInvoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports